import React, { useState } from 'react';

import Modal from 'react-modal';
import Button from '../../Forms/Button';

import './CartaPorte.info.general.scss';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
        padding: '0px 0px 6px',
        border: 'none',
        borderRadius: '12px',
        boxShadow: `0px 4px 16px rgba(0, 60, 128, 0.1)`,
    }
};

interface CartaPorteInfoGeneralDialogProps {
    isSelfReceptor: boolean;
}

export function CartaPorteInfoConceptosDialog({ isSelfReceptor }: CartaPorteInfoGeneralDialogProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const close = () => {
        setIsOpen(false);
    }
    const open = () => {
        setIsOpen(true);
    }
    return (
        <div className='_CartaPorteInfoDialog'>
            <div className='textIconTrigger' onClick={open}>
                <i className='material-icons'>help_outline</i>
            </div>
            <Modal
                isOpen={isOpen}
                onRequestClose={close}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="card table" id="CartaPorteGeneralDialog">
                    <div className="cardTitle">
                        {
                            isSelfReceptor ?
                                <h4>¿Porqué no hay opción de conceptos?</h4>
                                :
                                <h4>¿Como funciona los conceptos?</h4>
                        }
                    </div>
                    <div className="cardBody">
                        {
                            isSelfReceptor ?
                                <div className='_textHolder'>
                                    <p className='gray'>
                                        <b>Cuando se traslada tu propia mercancía </b>no hay conceptos a definir, ya que los productos a mover se agrega como Mercancías más adelante.
                                    </p>
                                    <p className='gray'>
                                        A partir de las mercancías, <b>la carta porte de traslado crea los conceptos con valor cero</b>, ya que el total de las facturas de traslado es siempre cero.
                                    </p>
                                </div>

                                :
                                <div className='_textHolder'>
                                    <p className='gray'>
                                        <b>En servicios de autotransporte</b> los conceptos a elegir deben estar solamente relacionados con el servicio autotransporte.
                                    </p>
                                    <p className='gray'>
                                        Debido a esto, las opciones de conceptos a agregar son limitadas. Conceptos en una Carta Porte de ingreso solamente están relacionados a las mercancías que se mueven.
                                    </p>
                                    <p>
                                        Si tienes algún otro servicio que se le cobra al cliente, tal como emplaye, costo de maniobras, etc. Es necesario agregarlo como una factura de ingreso por separado.
                                    </p>
                                </div>
                        }
                        <div className='row'>
                            <div className='row center centerY'>
                                <Button primary={true} handleClick={close}>
                                    <span>
                                        Entendido
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}